import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchPDD } from "../../services";
import { NoData } from "../../../../components/NoData";
import Pagination from "../../../../components/Pagination";
import { PddDocument } from "../../../../types";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { convertDateString } from "../../../../utils/convertDateString";
import { Spinner } from "@material-tailwind/react";
import { Cell, TableHeader, TableRow } from "../../../../components/Table";

const TABLE_DOCUMENT_HEADERS = [
  "ID",
  "Name",
  "Description",
  "Status",
  "Project ID",
  "Template ID",
  "User ID",
  "Created At",
  "Updated At",
];

const renderDocumentList = (documentsData: PddDocument[], navigate: NavigateFunction) => {
  return documentsData?.map((document: PddDocument) => {
    return (
      <TableRow
        key={`document-${document.id}`}
        onClick={() => navigate(`/Project-Design-Document/Add-New-PDD?pddID=${document.id}`)}
      >
        <Cell type="center">{document.id}</Cell>
        <Cell type="primary">{document.name}</Cell>
        <Cell type="line-clamp-2">{document.description}</Cell>
        <Cell type="center">{document.status}</Cell>
        <Cell>{document.project_id}</Cell>
        <Cell type="nowrap">{document.pdd_template_id}</Cell>
        <Cell>{document.user_id}</Cell>
        <Cell type="nowrap">
          {document.created_at ? convertDateString(document.created_at) : "Not available"}
        </Cell>
        <Cell type="nowrap">
          {document.updated_at ? convertDateString(document.updated_at) : "Not available"}
        </Cell>
      </TableRow>
    );
  });
};

export const PDDTable = () => {
  const [page, setPage] = useState<number>(1);
  const navigate = useNavigate();
  const limit = 10;

  const { data: allPDDDocuments, isFetching } = useQuery({
    queryKey: ["allPDDDocuments", page],
    initialData: { data: [], limit, skip: 0, total: 0 },
    queryFn: () => fetchPDD(page, limit),
  });

  return (
    <div className="min-w-full max-w-[calc(100vw-320px)] rounded-lg bg-white py-4 shadow-md">
      <div className="w-full max-w-full overflow-x-auto">
        {isFetching ? (
          <Spinner />
        ) : (
          <table>
            <TableHeader headers={TABLE_DOCUMENT_HEADERS} />
            <tbody className="border-b border-blue-gray-50">
              {allPDDDocuments.data.length > 0 ? (
                renderDocumentList(allPDDDocuments.data, navigate)
              ) : (
                <NoData />
              )}
            </tbody>
          </table>
        )}
      </div>
      <div className="mt-6 flex justify-center">
        <Pagination
          page={page}
          totalItems={allPDDDocuments.total}
          itemsPerPage={allPDDDocuments.limit}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
};
